import { Component, ViewChild, ElementRef } from '@angular/core';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  LatLng,
  Marker,
  Environment
} from '@ionic-native/google-maps';

import { NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { AlertProvider } from '../../providers/alert/alert';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';

declare var google;

@Component({
  selector: 'page-contact-us',
  templateUrl: 'contact-us.html',
})
export class ContactUsPage {
  @ViewChild('map') element;
  map: any;
  contact = {
    name: '',
    email: '',
    message: ''
  };
  constructor(
    public googleMaps: GoogleMaps,
    public http: Http,
    public config: ConfigProvider,
    public loading: LoadingProvider,
    public shared: SharedDataProvider,
    public navCtrl: NavController,
    public alert: AlertProvider,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.loadMap();
  }
  submit() {

    this.loading.show();
    var data = {};
    data = this.contact;
    this.http.post(this.config.url + 'contactUsGetCustomers', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      if (data.success == 1) {
        this.contact.name = '';
        this.contact.email = '';
        this.contact.message = '';
        this.alert.show(data.message);
      }
    }, function (response) {
      this.loading.hide();
      this.alert.show("Error server not reponding");
    });


  };

  loadMap(){

    let map: GoogleMap = this.googleMaps.create(this.element.nativeElement);

    map.one(GoogleMapsEvent.MAP_READY).then((data: any) => {

      let coordinates: LatLng = new LatLng(this.config.latitude, this.config.longitude);

      let position = {
        target: coordinates,
        zoom: 17,
          tilt: 60,
          duration: 0
      };

      map.animateCamera(position);

      let markerOptions: MarkerOptions = {
        position: coordinates,
        title: 'Get Customers'
      };

      const marker = map.addMarker(markerOptions)
        .then((marker: Marker) => {
          marker.showInfoWindow();
      });
    })
  }



  openCart() {
    this.navCtrl.push(CartPage);
}
openSearch() {
    this.navCtrl.push(SearchPage);
}

}



// WEBPACK FOOTER //
// ./src/pages/contact-us/contact-us.ts